var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10.5,
  stroke: "#5CC9E6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5CC9E6",
  fillRule: "evenodd",
  d: "m12.527 7.48 2.922 3.168c.18.194.18.51 0 .704l-2.922 3.169a.434.434 0 0 1-.65 0 .53.53 0 0 1 0-.704l2.138-2.319h-7.14c-.253 0-.458-.223-.458-.498s.205-.498.459-.498h7.14l-2.139-2.319a.53.53 0 0 1 0-.704.434.434 0 0 1 .65 0",
  clipRule: "evenodd"
})));
export default SvgArrowRight;